import { useApiClient } from 'clients/yogi-api'
import { BenchmarkingFeedHttpService } from 'features/trend-detection/features/benchmarking-feed/service/service'
import type { BenchmarkingFeedService } from 'features/trend-detection/features/benchmarking-feed/service/types'

export const useBenchmarkingFeedService = (): BenchmarkingFeedService => {
  const client = useApiClient()
  return new BenchmarkingFeedHttpService(client)
}

export type {
  BenchmarkingFeedService,
  FetchBenchmarkingInsightsParams,
} from 'features/trend-detection/features/benchmarking-feed/service/types'
